<template>
  <nuxt />
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  head() {
    const info = this.$store.getters["app/info"];
    const imgs = this.$store.getters["app/imgs"];
    const cleanDescription = (info.description || "").replace(/(<([^>]+)>)/gi, "").substring(0, 150) + "...";
    const keywords = info.keywords && info.keywords !== "undefined" ? info.keywords : "遊戲點數, 達人商城, 遊戲充值";
    return {
      title: info.name,
      meta: [
        {
          hid: "description",
          name: "description",
          content: cleanDescription,
        },
        {
          hid: "keywords",
          name: "keywords",
          content: keywords,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: info.name,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: cleanDescription,
        },
        {
          hid: "og:image",
          property: "og:image",
          content: imgs.logo,
        },
        {
          hid: "og:url",
          property: "og:url",
          content: info.web,
        },
      ],
      link: [
        {
          rel: "icon",
          type: "image/x-icon",
          href: imgs.logo,
        },
      ],
    };
  },
  mounted() {
    
  },
};
</script>
